import Splide from "@splidejs/splide";
import { Intersection } from "@splidejs/splide-extension-intersection";
import { Grid } from "@splidejs/splide-extension-grid";
import { PageNumber } from "./slider/PageNumber";

Splide.defaults = {
    mediaQuery: "min",
};

(function () {
    const sliders = document.getElementsByClassName("splide");

    for (let i = 0; i < sliders.length; i++) {
        let slider = sliders[i];

        // Prevent duplicate initialization by "data-splide-sync"
        if (slider.Splide || slider.classList.contains("splide--no-init")) {
            continue;
        }

        let splide = new Splide(slider);
        let extensions = { Intersection, Grid, PageNumber };

        slider.Splide = splide;

        let slidersToSync = [];
        if (slider.getAttribute("data-splide-sync")) {
            slidersToSync = document.querySelectorAll(slider.getAttribute("data-splide-sync"));
        }

        slidersToSync.forEach((sliderToSync) => {
            let sync = new Splide(sliderToSync);
            splide.sync(sync);
            sliderToSync.Splide = sync;
        });

        splide.mount(extensions);

        slidersToSync.forEach((sliderToSync) => {
            sliderToSync.Splide.mount(extensions);
        });
    }
})();
